<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import CheckModal from "@/components/CheckModal";
import appConfig from "@/../app.config";
import sgsstResourcesAPI from "@/services/standards/sgsstResources/sgsstResourcesAPI";
import itemFormatsAPI from "@/services/itemFormats/itemFormatsAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import Swal from "sweetalert2";
import { dateFormat } from "@/utils/helpers/format";
import { sendNotification } from "@/utils/helpers/notification";
import ItemAPI from "@/services/items/itemsAPI";

const STANDARD_ROLES = [
  { rol_comite: "Alta Dirección / Gerencia", responsabilidad: "Asignar y garantizar los recursos humanos, físicos, tecnológicos y financieros del SG-SST." },
  { rol_comite: "Responsable del SG-SST", responsabilidad: "Administrar y ejecutar los recursos asignados de acuerdo con la planeación anual." },
  { rol_comite: "COPASST / Vigía SST", responsabilidad: "Participar y vigilar el uso adecuado de los recursos del SG-SST." },
  { rol_comite: "Comité de Convivencia Laboral", responsabilidad: "Gestionar la convivencia y la prevención del acoso laboral." },
  { rol_comite: "Brigada de Emergencias", responsabilidad: "Atender emergencias con los recursos y equipos asignados." },
  { rol_comite: "Trabajadores / Colaboradores", responsabilidad: "Usar adecuadamente los recursos y los elementos de protección personal." },
];

const BUDGET_CATEGORIES = [
  { value: "humano", label: "Recurso Humano" },
  { value: "fisico_tecnologico", label: "Recurso Físico y Tecnológico" },
  { value: "emergencias", label: "Manejo de Emergencias" },
  { value: "medicina", label: "Medicina Laboral" },
  { value: "mantenimiento", label: "Mantenimiento y Prevención" },
];

export default {
  page: {
    title: "1.1.3. Asignación de Recursos para el SG SST",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, Style, PageHeader, CheckModal },
  data() {
    return {
      title: "1.1.3. Asignación de Recursos para el SG SST",
      items: [
        { text: "Estandares", href: "/forms/estandares" },
        { text: "1.1.3. Asignación de Recursos para el SG SST", active: true },
      ],
      budgetCategories: BUDGET_CATEGORIES,
      lista: [],
      loading: true,
      submitted: false,
      item: null,
      itemStatus: "No cumplido",
      itemData: null,
      form: {
        city: null,
        acta_date: null,
        responsibilities: STANDARD_ROLES.map((r) => ({
          rol_comite: r.rol_comite, responsabilidad: r.responsabilidad, designado: "", curso_licencia: "", estado: "",
        })),
        budget_items: [],
      },
      companyID: this.$store.getters["company/getCompany"].id || null,
      company: this.$store.getters["company/getCompany"] || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
    };
  },
  computed: {
    budgetSummary() {
      return BUDGET_CATEGORIES.map((c) => {
        const rows = this.form.budget_items.filter((b) => b.category === c.value);
        const programado = rows.reduce((s, r) => s + (Number(r.programado) || 0), 0);
        const ejecutado = rows.reduce((s, r) => s + (Number(r.ejecutado) || 0), 0);
        return { label: c.label, programado, ejecutado, saldo: programado - ejecutado };
      });
    },
    budgetTotals() {
      const s = this.budgetSummary;
      return {
        programado: s.reduce((a, x) => a + x.programado, 0),
        ejecutado: s.reduce((a, x) => a + x.ejecutado, 0),
        saldo: s.reduce((a, x) => a + x.saldo, 0),
      };
    },
  },
  methods: {
    dateConvert(date) {
      return dateFormat(date);
    },
    money(v) {
      return "$" + new Intl.NumberFormat("es-CO").format(Math.round(Number(v) || 0));
    },
    getItemData() {
      ItemAPI.getItems(3).then((r) => (this.itemData = r)).catch((e) => console.log(e));
    },
    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 3)
        .then((r) => {
          this.item = r || null;
          this.itemStatus = r && r.status !== undefined ? r.status : this.itemStatus;
        })
        .catch((e) => console.log(e));
    },
    allowAccess() {
      try {
        const item = this.itemData;
        const c = this.$store.getters["company/getCompany"].company_classification_id || null;
        if (!item) return false;
        if (c === 1 && item.obligatory_UPA === 1) return true;
        if (c === 2 && item.obligatory_groupI === 1) return true;
        if (c === 3 && item.obligatory_groupII === 1) return true;
        if (c === 4 && item.obligatory_groupIII === 1) return true;
        return false;
      } catch (e) {
        return false;
      }
    },
    getRole(name, roles) {
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null;
      if (!role) return false;
      if (roles) role = roles.includes(role);
      else role = [1, 2, 3, 4, 5, 6, 7, 8].includes(role);
      const enabled = this.$store.state.auth.info.permissions.find((p) => p.name === name);
      return enabled && role ? true : false;
    },
    changeItemStatus(itemStatus) {
      newScoresAPI.calculateScores({ companies_id: this.companyID, item_id: 3, status: itemStatus })
        .then(() => {
          Swal.fire({ title: "¡Éxito!", text: "¡Estado del ítem actualizado!", icon: "success", confirmButtonClass: "btn btn-confirm mt-2" });
          setTimeout(() => window.location.reload(), 1500);
        })
        .catch(() => Swal.fire("Error", "No se actualizó el estado", "error"));
    },
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },
    getList() {
      sgsstResourcesAPI.getAll(this.companyID, 1, "")
        .then((res) => {
          this.lista = (res && res.Resource_allocation && res.Resource_allocation.data) || [];
          this.loading = false;
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
        });
    },
    // Descarga de documentos diligenciados cargados anteriormente (flujo anterior).
    openFile(url) {
      window.open(url, "_blank");
    },
    addRow() {
      this.form.responsibilities.push({ rol_comite: "", responsabilidad: "", designado: "", curso_licencia: "", estado: "" });
    },
    removeRow(i) {
      this.form.responsibilities.splice(i, 1);
    },
    addBudgetRow() {
      this.form.budget_items.push({ category: "humano", rubro: "", area: "", requerimiento: "", descripcion_tecnica: "", proveedor: "", tarifa: 0, cantidad: 0, periodicidad: "", programado: 0, ejecutado: 0 });
    },
    removeBudgetRow(i) {
      this.form.budget_items.splice(i, 1);
    },
    downloadFormato() {
      itemFormatsAPI.list("1.1.3").then((res) => {
        const f = ((res && res.data) || [])[0];
        if (f) window.location.href = itemFormatsAPI.url(f.bucket_key);
      }).catch((e) => console.log(e));
    },
    save() {
      this.submitted = true;
      sgsstResourcesAPI
        .save({
          companies_id: this.companyID,
          city: this.form.city,
          acta_date: this.form.acta_date,
          responsibilities: this.form.responsibilities,
          budget_items: this.form.budget_items,
        })
        .then((res) => {
          newScoresAPI.calculateScores({ companies_id: this.companyID, item_id: 3, status: "Pendiente" })
            .then(() => {
              Swal.fire({ title: "¡Éxito!", text: "¡Acta de recursos creada!", icon: "success", timer: 1800, showConfirmButton: false });
              const id = res && res.id;
              if (id) this.$router.push({ path: `/forms/estandares/recursos-sgsst/${id}` });
              else setTimeout(() => window.location.reload(), 1800);
            })
            .catch(() => (this.submitted = false));
        })
        .catch((e) => {
          console.log(e);
          this.submitted = false;
          Swal.fire("Error", "No se pudo crear el acta", "error");
        });
    },
    deleteRecurso(id) {
      Swal.fire({ icon: "warning", title: "¿Eliminar esta acta?", showCancelButton: true, confirmButtonText: "Eliminar", cancelButtonText: "Cancelar" })
        .then((ok) => {
          if (!ok.isConfirmed) return;
          sgsstResourcesAPI.delete(id)
            .then(() => {
              this.lista = this.lista.filter((x) => x.id !== id);
              Swal.fire({ icon: "success", title: "Eliminada", timer: 1200, showConfirmButton: false });
            })
            .catch(() => Swal.fire("Error", "No se pudo eliminar", "error"));
        });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.getItems();
    this.getItemData();
    this.getList();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div v-if="!loading && classificationID <= 4">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      Describe los recursos humanos, técnicos y financieros para la ejecución del SG-SST.
                      Diligencia los datos en la app; la plataforma genera el acta para firma del representante legal.
                    </p>
                  </CheckModal>
                </div>
                <div class="col-6 text-right m-b-0">
                  <button :disabled="!allowAccess()" @click="downloadFormato" class="btn btn-primary mx-1">
                    <span class="btn-label"><i class="bx bx-download"></i></span> Formato presupuesto SG-SST
                  </button>
                </div>
              </div>

              <div class="row">
                <div class="col-6"></div>
                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()"
                      plain class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-2">
                  <b-form-group class="col-md-6 px-2" label="Ciudad">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" v-model="form.city" placeholder="Ciudad"></b-form-input>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Fecha del acta">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" type="date" v-model="form.acta_date"></b-form-input>
                  </b-form-group>
                </div>

                <label class="font-weight-bold mt-2">1. Asignación de responsabilidades y recurso humano</label>
                <div class="table-responsive">
                  <table class="table table-sm table-bordered">
                    <thead class="table-active">
                      <tr>
                        <th style="min-width:140px">Rol / Comité</th>
                        <th style="min-width:220px">Responsabilidad Principal</th>
                        <th style="min-width:140px">Designado</th>
                        <th style="min-width:120px">Curso 50h / Licencia</th>
                        <th style="min-width:90px">Estado</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(r, i) in form.responsibilities" :key="'r' + i">
                        <td><b-form-input size="sm" v-model="r.rol_comite"></b-form-input></td>
                        <td><b-form-textarea rows="2" size="sm" v-model="r.responsabilidad"></b-form-textarea></td>
                        <td><b-form-input size="sm" v-model="r.designado"></b-form-input></td>
                        <td><b-form-input size="sm" v-model="r.curso_licencia"></b-form-input></td>
                        <td><b-form-input size="sm" v-model="r.estado"></b-form-input></td>
                        <td class="text-center align-middle">
                          <button type="button" class="btn btn-sm btn-outline-danger" @click="removeRow(i)"><i class="mdi mdi-trash-can"></i></button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <button type="button" class="btn btn-sm btn-light" @click="addRow">+ Agregar fila</button>
                </div>

                <label class="font-weight-bold mt-3">2. Plan de compras y presupuesto detallado</label>
                <div class="table-responsive">
                  <table class="table table-sm table-bordered" style="min-width:1150px">
                    <thead class="table-active">
                      <tr>
                        <th style="min-width:150px">Categoría</th>
                        <th>Rubro</th><th>Área</th><th>Requerimiento</th><th style="min-width:160px">Descripción técnica</th><th>Proveedor</th>
                        <th style="min-width:90px">Tarifa</th><th style="min-width:70px">Cant.</th><th>Periodic.</th>
                        <th style="min-width:100px">Programado</th><th style="min-width:100px">Ejecutado</th><th style="min-width:90px">Saldo</th><th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(b, i) in form.budget_items" :key="'b' + i">
                        <td>
                          <select class="form-control form-control-sm" v-model="b.category">
                            <option v-for="c in budgetCategories" :key="c.value" :value="c.value">{{ c.label }}</option>
                          </select>
                        </td>
                        <td><b-form-input size="sm" v-model="b.rubro"></b-form-input></td>
                        <td><b-form-input size="sm" v-model="b.area"></b-form-input></td>
                        <td><b-form-input size="sm" v-model="b.requerimiento"></b-form-input></td>
                        <td><b-form-textarea rows="2" size="sm" v-model="b.descripcion_tecnica"></b-form-textarea></td>
                        <td><b-form-input size="sm" v-model="b.proveedor"></b-form-input></td>
                        <td><b-form-input size="sm" type="number" v-model.number="b.tarifa"></b-form-input></td>
                        <td><b-form-input size="sm" type="number" v-model.number="b.cantidad"></b-form-input></td>
                        <td><b-form-input size="sm" v-model="b.periodicidad"></b-form-input></td>
                        <td><b-form-input size="sm" type="number" v-model.number="b.programado"></b-form-input></td>
                        <td><b-form-input size="sm" type="number" v-model.number="b.ejecutado"></b-form-input></td>
                        <td class="text-right align-middle small">{{ money((Number(b.programado) || 0) - (Number(b.ejecutado) || 0)) }}</td>
                        <td class="text-center align-middle">
                          <button type="button" class="btn btn-sm btn-outline-danger" @click="removeBudgetRow(i)"><i class="mdi mdi-trash-can"></i></button>
                        </td>
                      </tr>
                      <tr v-if="!form.budget_items.length"><td colspan="13" class="text-center text-muted">Sin ítems de presupuesto. Agrega con el botón.</td></tr>
                    </tbody>
                  </table>
                  <button type="button" class="btn btn-sm btn-light" @click="addBudgetRow">+ Agregar ítem</button>
                </div>

                <label class="font-weight-bold mt-3">Resumen de presupuesto (auto-calculado)</label>
                <table class="table table-sm table-bordered" style="max-width:680px">
                  <thead class="table-active"><tr><th>Tipo de Recurso</th><th class="text-right">Programado</th><th class="text-right">Ejecutado</th><th class="text-right">Saldo</th></tr></thead>
                  <tbody>
                    <tr v-for="(s, i) in budgetSummary" :key="'s' + i">
                      <td>{{ s.label }}</td>
                      <td class="text-right">{{ money(s.programado) }}</td>
                      <td class="text-right">{{ money(s.ejecutado) }}</td>
                      <td class="text-right">{{ money(s.saldo) }}</td>
                    </tr>
                    <tr class="font-weight-bold">
                      <td>TOTAL</td>
                      <td class="text-right">{{ money(budgetTotals.programado) }}</td>
                      <td class="text-right">{{ money(budgetTotals.ejecutado) }}</td>
                      <td class="text-right">{{ money(budgetTotals.saldo) }}</td>
                    </tr>
                  </tbody>
                </table>

                <div class="form-group text-right m-b-0 mt-3">
                  <button :disabled="submitted || !getRole('Crear') || !allowAccess()" type="submit" class="btn btn-primary">Guardar</button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
                </div>
              </form>

              <hr v-if="getRole('Consultar')" />

              <div v-if="getRole('Consultar')" class="table-responsive">
                <table class="table table-striped border-bottom">
                  <thead>
                    <tr>
                      <th class="text-center">ID</th>
                      <th class="text-left">Fecha de creación</th>
                      <th class="text-center">Estado</th>
                      <th class="text-center">Documento diligenciado</th>
                      <th class="text-center">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!lista.length"><td colspan="5" class="text-center text-muted">Aún no hay actas registradas.</td></tr>
                    <tr v-for="dato in lista" :key="dato.id">
                      <td class="text-center align-middle"><b>{{ dato.id }}</b></td>
                      <td class="text-left align-middle">{{ dateConvert(dato.created_at) }}</td>
                      <td class="text-center align-middle">
                        <span class="badge" :class="dato.workflow_status === 'signed' ? 'badge-success' : 'badge-secondary'">
                          {{ dato.workflow_status === 'signed' ? 'Firmada' : 'Borrador' }}
                        </span>
                      </td>
                      <td class="text-center align-middle">
                        <button v-if="dato.file" style="background-color: transparent !important; border: none;"
                          type="button" @click="openFile(dato.file)" title="Descargar documento cargado">
                          <i class="mdi mdi-cloud-download" style="font-size:1.3rem;"></i>
                        </button>
                        <span v-else class="text-muted">—</span>
                      </td>
                      <td class="text-center align-middle">
                        <b-dropdown variant="primary" :disabled="!allowAccess()">
                          <template v-slot:button-content><i class="mdi mdi-eye"></i></template>
                          <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()"
                            :to="{ path: `/forms/estandares/recursos-sgsst/${dato.id}` }">Editar / Firmar</b-dropdown-item>
                          <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()"
                            v-on:click="deleteRecurso(dato.id)">Eliminar</b-dropdown-item>
                        </b-dropdown>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-center"><b-spinner variant="primary" label="Loading..."></b-spinner></div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal { background-color: transparent !important; border: none; }
</style>
